import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const BoltOff = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M23.2097 3.16032C23.6735 3.46016 23.8064 4.07921 23.5066 4.54302L18.346 12.5259L17.1144 10.747L21.827 3.45722C22.1268 2.99341 22.7459 2.86049 23.2097 3.16032ZM15.754 16.5353L13.8374 19.5001H17.8294L15.754 16.5353ZM19.2294 21.5001H12.0001C11.6339 21.5001 11.2969 21.2999 11.1218 20.9782C10.9467 20.6565 10.9615 20.2648 11.1603 19.9572L14.5159 14.7665L10.1809 8.57358C9.86414 8.12113 9.97417 7.4976 10.4266 7.18088C10.8791 6.86417 11.5026 6.9742 11.8193 7.42665L29.3193 32.4267C29.636 32.8791 29.526 33.5026 29.0735 33.8193C28.6211 34.1361 27.9976 34.026 27.6809 33.5736L24.0721 28.4182L18.1733 37.543C17.8734 38.0068 17.2544 38.1398 16.7906 37.8399C16.3267 37.5401 16.1938 36.921 16.4937 36.4572L22.834 26.6495L19.2294 21.5001ZM24.5589 21.5001L23.1743 19.5001H28.0001C28.3664 19.5001 28.7033 19.7004 28.8784 20.0221C29.0535 20.3437 29.0388 20.7354 28.8399 21.043L26.6199 24.4771L25.3884 22.6982L26.1629 21.5001H24.5589Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default BoltOff;
